import React, { memo } from 'react';
import './footer.scss';

const Footer = () => (
  <footer id="footer" className="on-footer">
    <div className="footer-container">
      <div className="footer-row">
        <div className="footer-branding">
          <img
            src="https://assets.thesparksite.com/uploads/sites/834/2019/07/compass-logo-black.svg"
            alt="Site Logo"
            className="logo-compass"
            srcSet="https://assets.thesparksite.com/uploads/sites/834/2019/07/compass-logo-black.svg 2x"
          />
          <p className="footer-branding-copy">
            Joseph Arendsen - CA DRE#01841681 <br /> 682 S Coast Hwy 101 Ste 110, Encinitas CA 92024
          </p>
        </div>

        <div className="footer-links-wrapper">
          <ul className="footer-links">
            <li className="footer-link">
              <a href="https://truelocalrealty.com">Home</a>
            </li>
            <li className="footer-link">
              <a href="https://truelocalrealty.com/buyers/">Buyers</a>
            </li>
            <li className="footer-link">
              <a href="https://truelocalrealty.com/sellers/">Sellers</a>
            </li>
            <li className="footer-link">
              <a href="https://truelocalrealty.com/success-stories/">Success Stories</a>
            </li>
          </ul>
        </div>

        <div className="footer-links-wrapper">
          <ul className="footer-links">
            <li className="footer-link">
              <a href="https://truelocalrealty.com/properties/">Property Search</a>
            </li>
            <li className="footer-link">
              <a href="https://truelocalrealty.com/explore-areas/">Explore Areas</a>
            </li>
            <li className="footer-link">
              <a href="https://truelocalrealty.com/off-market/">Off Market Homes</a>
            </li>
            <li className="footer-link">
              <a href="https://joseph.truelocalrealty.com/sell.php">Instant Home Value</a>
            </li>
          </ul>
        </div>

        <div className="footer-links-wrapper">
          <ul className="footer-links">
            <li className="footer-link">
              <a href="https://www.facebook.com/TrueLocalRealty">Facebook</a>
            </li>
            <li className="footer-link">
              <a href="https://www.instagram.com/truelocalrealty/">Instagram</a>
            </li>
            <li className="footer-link">
              <a href="https://www.youtube.com/channel/UCAH6oZHy7fqwo7CawL83w1A">YouTube</a>
            </li>
            <li className="footer-link">
              <a href="https://www.yelp.com/biz/joseph-arendsen-true-local-realty-group-encinitas">Yelp</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-row">
        <div className="footer-branding-realtor">
          <img
            src="https://assets.thesparksite.com/mu-plugins/agentfire-shared-library/classes/agentfire/plugin/spark-page/image/realtor-logo-AUTOx50.fit.png"
            className=""
            alt="Disclaimer Logo"
            srcSet="https://assets.thesparksite.com/mu-plugins/agentfire-shared-library/classes/agentfire/plugin/spark-page/image/realtor-logo-AUTOx100.fit.png 2x"
          />
          <p className="footer-branding-realtor-copy">&copy; 2019 - All Rights Reserved</p>
        </div>

        <div className="footer-links-wrapper">
          <ul className="footer-links">
            <li className="footer-link">
              <a href="https://truelocalrealty.com/blog/">Blog</a>
            </li>
            <li className="footer-link">
              <a href="https://truelocalrealty.com/careers/">Careers</a>
            </li>
            <li className="footer-link">
              <a href="https://truelocalrealty.com/meet-the-team/">Meet The Team</a>
            </li>
          </ul>
        </div>

        <div className="footer-links-wrapper">
          <ul className="footer-links">
            <li className="footer-link">
              <a href="https://truelocalrealty.com/faq/">FAQ</a>
            </li>
            <li className="footer-link">
              <a href="https://truelocalrealty.com/contact-us/">Contact Us</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

Footer.defaultProps = { children: null };

export default memo(Footer);
